import Evented from './Evented'
import HostChannel from './HostChannel'
import ISubscriptionConfig from './interfaces/ISubscriptionConfig'

export class Metrics extends Evented {
  private backends: Map<string, HostChannel> = new Map()

  public registerHost (host: HostChannel, options: ISubscriptionConfig) {
    const backendInfo = `${options.ssl ? 'secure:' : 'insecure'}${options.host}`

    host.on('up', () => this.emit('up', backendInfo))
    host.on('down', () => this.emit('down', backendInfo))
    host.on('heartbeat', () => this.emit('heartbeat', backendInfo))

    this.backends.set(backendInfo, host)
  }

  public generate () {
    const out: {
      [index: string]: object
    } = {}
    this.backends.forEach((host, key) => {
      out[key] = host.metrics
    })
    return out
  }
}
